import React from 'react';
import { Chip, Paper, Stack, Tooltip, Typography } from '@mui/material';
import ReportSection from './ReportSection';
import EmptyState from './EmptyState';
import { formatMoney, formatNumber } from '../utils/formatters';

const OrderServiceTypeRanking = ({ services = [] }) => {
    return (
        <ReportSection
            title="Desempeño por servicio"
            subtitle="Servicios con mayor movimiento económico"
        >
            {services.length === 0 ? (
                <EmptyState />
            ) : (
                <Stack spacing={1}>
                    {services.slice(0, 8).map((item) => (
                        <Paper
                            key={item.service_project_id}
                            variant="outlined"
                            sx={{ p: 1.5, borderRadius: 2 }}
                        >
                            <Stack direction="row" justifyContent="space-between" spacing={2}>
                                <div>
                                    <Typography variant="body2" fontWeight={800}>
                                        {item.service_name}
                                    </Typography>

                                    <Stack direction="row" spacing={1} sx={{ mt: 0.7 }}>
                                        <Chip
                                            size="small"
                                            label={item.is_internal ? 'Interno' : 'Externo'}
                                            color={item.is_internal ? 'info' : 'default'}
                                            variant="outlined"
                                        />

                                        <Chip
                                            size="small"
                                            label={`${formatNumber(item.total_orders)} OS`}
                                            variant="outlined"
                                        />
                                    </Stack>
                                </div>

                                <Tooltip title={`Promedio: ${formatMoney(item.avg_amount)}`}>
                                    <Typography variant="body2" fontWeight={900}>
                                        {formatMoney(item.total_amount)}
                                    </Typography>
                                </Tooltip>
                            </Stack>
                        </Paper>
                    ))}
                </Stack>
            )}
        </ReportSection>
    );
};

export default OrderServiceTypeRanking;